import React, { useEffect, useState } from "react";
import { RouterProvider } from "react-router-dom";
import { FluentProvider, makeStyles } from "@fluentui/react-components";
import { applyTheme, customWebLightTheme } from "./utils/Theming";
import { createAppRouter } from "./routes";
import { MessageProvider } from "./blocks/message/MessageContext";
import Message from "./blocks/message/Message";

const useStyles = makeStyles({
  root: {
    height: "100vh",
    position: "relative",
    overflow: "hidden",
  }
});

const App = () => {
  const styles = useStyles();
  const [theme, setTheme] = useState(customWebLightTheme);
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (!initialized) {
      Office.onReady(() => {
        setInitialized(true);

        if (Office.context.host === Office.HostType.Outlook) {
          const mailbox = Office.context.mailbox;

          setTheme(applyTheme(Office.context.officeTheme));

          mailbox.addHandlerAsync(Office.EventType.OfficeThemeChanged, (eventArgs) => {
            setTheme(applyTheme(eventArgs.officeTheme));
          });

          mailbox.addHandlerAsync(Office.EventType.ItemChanged, () => {
            setInitialized(false);
          });
        }
      });
    }
  }, [initialized]);

  const router = createAppRouter();

  return (
    <FluentProvider theme={theme}>
      <div className={styles.root}>
        <MessageProvider>
          <Message />
          {initialized && <RouterProvider router={router} />}
        </MessageProvider>
      </div>
    </FluentProvider>
  );
};

export default App;
